/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectCreateUpdateDashboardDto } from '../../models/project-create-update-dashboard-dto';
import { ProjectResponseDashboardDto } from '../../models/project-response-dashboard-dto';

export interface DashboardProjectsControllerUpdateProjectV1$Params {
  id: string;
  
    /**
     * Project data with optional image upload (partial update supported)
     */
    body: ProjectCreateUpdateDashboardDto
}

export function dashboardProjectsControllerUpdateProjectV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerUpdateProjectV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseDashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerUpdateProjectV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseDashboardDto>;
    })
  );
}

dashboardProjectsControllerUpdateProjectV1.PATH = '/v1/dashboard/projects/{id}';
